export const DEFAULT_STALE_TIME = 5 * 60 * 1000;
export const PRIMARY_NAV_STALE_TIME = 5 * 60 * 1000;
export const QUERY_GC_TIME = 30 * 60 * 1000;
